export { InvoicesComponent } from "./invoices.component";
export { InvoicesModule } from "./invoices.module";
//export { AssetsRoutingModule } from "./assets-routing.module";
